export default __webpack_public_path__ + "images/referenzen/werbespot/tesa_tvc_powerstrips_transparen.mp4";